export const compareObjectsGetDiferences = (obj1: any, obj2: any) => {
    let changes: { op: string, path: string, value: any }[] = [];
    Object.keys(obj1).forEach(key => {
        if (obj2.hasOwnProperty(key)) {
            if (obj1[key] !== obj2[key] || (obj1[key] === undefined && obj2[key] !== undefined) || (obj1[key] !== undefined && obj2[key] === undefined)) {
                changes.push({
                    op: 'replace',
                    path: `/${key}`,
                    value: obj2[key]
                });
            }
        }
    });
    return changes;
};